const env = {
  appUrl: import.meta.env["VITE_APP_URL"] as string,
  apiUrl: import.meta.env["VITE_API_URL"] as string,
  sameOriginApi: String(import.meta.env["VITE_SAME_ORIGIN_API"] ?? "false").toLowerCase() === "true",

  oauthClientId: import.meta.env["VITE_OAUTH_CLIENT_ID"] as string | undefined,
  oauthClientSecret: import.meta.env["VITE_OAUTH_CLIENT_SECRET"] as string | undefined,
} as const;

export default env;
